import { render, staticRenderFns } from "./ApprovalsList.vue?vue&type=template&id=42bc882e"
import script from "./ApprovalsList.vue?vue&type=script&lang=js"
export * from "./ApprovalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports